import { render, staticRenderFns } from "./TableInspect.vue?vue&type=template&id=8b06e584&scoped=true"
import script from "./TableInspect.vue?vue&type=script&lang=js"
export * from "./TableInspect.vue?vue&type=script&lang=js"
import style0 from "./TableInspect.vue?vue&type=style&index=0&id=8b06e584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b06e584",
  null
  
)

export default component.exports